import React from 'react';

function Comments(props) {
    return (
        <div>
            
        </div>
    );
}

export default Comments;